export const purchaseButtonClassName = 'lbx-add-to-cart';
